import React from 'react';

import Avatar from '@material-ui/core/Avatar';

const avatarStyle = {height: 25, width: 25, marginRight: 7};

const UserAvatarValue = (props) => {
  const {selectProps, data} = props;
  const {SingleValueProps = {noWrap: true}} = selectProps;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: 'calc(100% - 6px)',
      }}
    >
      <Avatar alt={data.name} src={data.picture} style={avatarStyle} />

      <div
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: SingleValueProps.noWrap ? 'nowrap' : 'normal',
        }}
      >
        {data.name}
      </div>
    </div>
  );
};

export default UserAvatarValue;
